import {
  applyMiddleware,
  combineReducers,
  createStore,
} from 'redux';
import {
  persistReducer,
  persistStore,
} from 'redux-persist';
import storage
  from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { thunk } from 'redux-thunk';

import userReducer from './reducers/userReducer'; // Your user reducer
import utilsReducer from './reducers/UtilReducer';
import matchesReducer from './reducers/matchesReducer';

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "matches"], // Persist user and matches
  blacklist: [], // No blacklist
  // Add a transform to handle logout properly
  transforms: [],
};

const rootReducer = combineReducers({
  user: userReducer,
  utils: utilsReducer,
  matches: matchesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  applyMiddleware(thunk) // Correct application of redux-thunk
);
export const persistor = persistStore(store);
